export default {"src":"/_next/static/media/home-fill.201c0e64.svg","height":12,"width":11};